import { AppendTextToIdeaNodeResponse } from "../pages/SummarySession";
import { IdeaNode, UserActionType } from "./shared_types";

export const _appendTextToIdeaNode = (
  state: any,
  appendTextToIdeaNodeResponse: AppendTextToIdeaNodeResponse
) => {
  const targetNodeId = nodeIdFromNodeIdPath(
    appendTextToIdeaNodeResponse.node_id_path
  );
  const ideaNode = {
    id: targetNodeId,
    title: "fixed title",
    description: appendTextToIdeaNodeResponse.text_to_append,
    research_session_id: appendTextToIdeaNodeResponse.research_session_id,
    node_type:
      appendTextToIdeaNodeResponse.research_session_id as UserActionType,
  };

  if (state.rootNode === undefined || state.rootNode === null) {
    state.rootNode = ideaNode;
    state.focusedNodeIdPath = stringPathForNodeId(null, ideaNode.id);
  } else {
    const targetNode = findNodeWithIdPath(
      state.rootNode as IdeaNode,
      appendTextToIdeaNodeResponse.node_id_path
    );
    if (targetNode) {
      targetNode.description =
        targetNode.description +
        appendTextToIdeaNodeResponse.text_to_append;
    } else {
      const parentNodeIdPath = parentNodeIdPathFromNodeIdPath(
        appendTextToIdeaNodeResponse.node_id_path
      );
      const parentNode = findNodeWithIdPath(
        state.rootNode as IdeaNode,
        parentNodeIdPath
      );
      console.log("attempting to find parent node instead...");
      console.log(parentNodeIdPath);
      if (parentNode) {
        // We need to append to children nodes
        // TODO: We should make sure the order matches / the node is inserted at the right index
        if (
          parentNode.ordered_children_nodes &&
          parentNode.ordered_children_nodes.length
        ) {
          parentNode.ordered_children_nodes?.push(ideaNode);
        } else {
          parentNode.ordered_children_nodes = [ideaNode];
        }
      } else {
        const errorMessage = `Error, could not find parent node in "appendTextToIdeaNode" operation, target node ${appendTextToIdeaNodeResponse.node_id_path} - session id: ${appendTextToIdeaNodeResponse.research_session_id}`;
        console.log(errorMessage);
        throw new Error(errorMessage);
      }
    }
  }
};

export const pathSeparatorString = "::";

export const nodeIdFromNodeIdPath = (nodeIdPath: string) => {
  const re = new RegExp(pathSeparatorString);
  const _nodeIds = nodeIdPath.split(re);
  const nodeIds = _nodeIds.filter((el) => el !== "");
  const targetNodeId = nodeIds.slice(-1)[0];
  return targetNodeId;
};

export const parentNodeIdPathFromNodeIdPath = (nodeIdPath: string) => {
  const re = new RegExp(pathSeparatorString);
  const _nodeIds = nodeIdPath.split(re);
  const nodeIds = _nodeIds.filter((el) => el !== "");
  const parentNodeIdPath = nodeIds.slice(0, -1).join(pathSeparatorString);
  return parentNodeIdPath;
};

export const findNodeWithIdPath = (rootNode: IdeaNode, nodeIdPath: string) => {
  const re = new RegExp(pathSeparatorString);
  const _nodeIds = nodeIdPath.split(re);
  const nodeIds = _nodeIds.filter((el) => el !== "");

  //   debugger;

  if (rootNode.id !== nodeIds[0]) {
    return null;
  } else if (nodeIds.length === 1 && rootNode.id === nodeIds[0]) {
    return rootNode;
  }

  let targetNode: IdeaNode | null = rootNode;

  const allParentsExceptRoot = nodeIds.slice(1);
  for (const [index, value] of allParentsExceptRoot.entries()) {
    const nextNodeInChain: IdeaNode | undefined =
      targetNode?.ordered_children_nodes?.find((node) => node.id == value);
    if (nextNodeInChain) {
      targetNode = nextNodeInChain;
    } else {
      console.log(`Can't find node ${value} (on path ${nodeIds})`);
      targetNode = null;
      return null;
    }
  }
  return targetNode;
};

export const stringPathForNodeId = (
  parentPath: string | undefined | null,
  nodeId: string
) => {
  if (parentPath === undefined || parentPath === null) {
    return String(nodeId) + pathSeparatorString;
  } else {
    return parentPath + String(nodeId) + pathSeparatorString;
  }
};
